import React from 'react';
import styled from 'styled-components';

interface ValidationErrorProps {
  message?: string;
}

const ErrorMessage = styled.div`
  color: #a72929;
  font-family: Clear Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 0.85rem;
  margin-top: 0.25rem;
`;

const ValidationError = ({ message }: ValidationErrorProps) =>
  message ? (
    <ErrorMessage aria-live="polite" role="alert">
      {message}
    </ErrorMessage>
  ) : null;

export { ValidationError };
